import graph from "./graph";
import Lottie from "react-lottie";
import animationData from "assets/json/alert.json";

import { useState } from "react";
import { useQuery } from "@apollo/client";
import { useSelector } from "react-redux";
import { Button, Stack, Typography } from "@mui/material";
import { NewDialog, NewDialogContent, NewDialogActions } from "components";

const defaultOptions = {
  loop: false,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const types = {
  ACTIVATE_LAB: "درخواست فعالسازی لابراتوار",
  ACTIVATE_UNIT: "درخواست فعالسازی کلینیک",
};

function getType(type) {
  return types[type] || type;
}

export default function LastRequest() {
  const { userToken } = useSelector((state) => state.auth);

  const {
    data,
    error,
    loading,
    refetch: refresh,
  } = useQuery(graph.request.query, {
    variables: {
      limit: 1,
      status: "REJECTED",
    },
    context: {
      serviceName: graph.request.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const refetch = () => refresh();

  if (error || loading) {
    return;
  }

  const { data: request, total } = data[graph.request.name];

  if (total > 0) {
    return <Content data={request[0]} />;
  }
}

function Content({ data }) {
  const { type, details } = data;
  const [open, setOpen] = useState(true);
  const onClose = () => setOpen(false);

  return (
    <NewDialog label="last-request" open={open} onClose={onClose}>
      <NewDialogContent isPopup>
        <Stack
          p={1}
          flex={1}
          rowGap={2}
          alignItems="center"
          bgcolor="background.paper"
        >
          <Lottie options={defaultOptions} height={160} width={160} />
          <Typography variant="subtitle1" color="error">
            {getType(type)}
          </Typography>
          <Typography variant="subtitle1" color="error" gutterBottom>
            توسط مدیر سامانه رد شد.
          </Typography>
          {details && (
            <>
              <Typography variant="caption" color="textDisabled">
                علت رد درخواست:
              </Typography>
              <Typography variant="body2" color="textSecondary" align="justify">
                {details}
              </Typography>
            </>
          )}
        </Stack>
      </NewDialogContent>
      <NewDialogActions>
        <Button
          autoFocus
          fullWidth
          size="large"
          color="warning"
          variant="contained"
          onClick={onClose}
        >
          متوجه شدم
        </Button>
      </NewDialogActions>
    </NewDialog>
  );
}
